<template>
  <div class="article-page">
    <my-header title="Terms Of Service"></my-header>
    <div class="content">
      <div class="title">Article Title</div>
      <div class="cont">
        <p>Please read this disclaimer before using our cryptocurrency website. The following terms and conditions apply to all users of our website.</p>
        <p>1.No Financial Advice:The information on this website is for general informational purposes only and should not be considered as financial advice. It is your responsibility to evaluate the accuracy and usefulness of the information before making any investment decisions.</p>
        <p>2.Cryptocurrency investments involve risk. The value of cryptocurrencies can fluctuate, and you may lose your investment. Consider your investment objectives and risk tolerance before engaging in cryptocurrency transactions.</p>
        <p>3.We do not endorse or control the content of third-party websites linked on our website. We are not responsible for the accuracy or reliability of any third-party materials.</p>
        <p>4.We strive to maintain the security of our website but cannot guarantee the security of information transmitted through the internet. We are not liable for any unauthorized access to your information.</p>
        <p>By using our website, you agree to the above disclaimer. If you do not agree, please refrain from using our website.</p>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from '@/components/MyHeader.vue';
export default {
  components: { MyHeader },
  name: "termsOfService",
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style lang="less" scoped></style>